<template>
    <MFACreateForm :authenticationMethods="authenticationMethods" :credential="credential" :redirect="redirect"
      :defaultContact="defaultContact">
    </MFACreateForm>
  </template>

  <script>
  import MFACreateForm from "@/Components/MFA/MFACreateForm.vue";

  export default {
    components: {
      MFACreateForm
    },
    props: {
      redirect: String,
      authenticationMethods: Object,
      credential: Object,
      defaultContact: String,
    },
    data() {
      return {}
    },
    methods: {},
    computed: {}
  }
  </script>
